import { VehicleNumberPlateType } from '~/shared';

export interface PlateTypeOption {
	id: string;
	type: VehicleNumberPlateType;
	hasFlag: boolean;
	isBlack?: boolean;
	label?: string;
}

export const plateTypeList: PlateTypeOption[] = [
	{
		id: 'classic',
		type: VehicleNumberPlateType.Classic,
		hasFlag: true,
		label: 'Флаговые номера',
	},
	{
		id: 'classic-no-flag',
		type: VehicleNumberPlateType.ClassicNoFlag,
		hasFlag: false,
		label: 'Номера без флага',
	},
	// {
	// 	id: 'classic-bold',
	// 	type: VehicleNumberPlateType.Classic,
	// 	hasFlag: true,
	// },
	// {
	// 	id: 'classic-no-flag-bold',
	// 	type: VehicleNumberPlateType.ClassicNoFlag,
	// 	hasFlag: false,
	// },
	// {
	// 	id: 'classic-square',
	// 	type: VehicleNumberPlateType.ClassicSquare,
	// 	hasFlag: true,
	// 	label: 'Квадратные номера',
	// },
	{
		id: 'classic-square-no-flag',
		type: VehicleNumberPlateType.ClassicSquareNoFlag,
		hasFlag: false,
		label: 'Квадратные номера без флага',
	},
	{
		id: 'custom',
		type: VehicleNumberPlateType.Custom,
		hasFlag: false,
		label: 'Именные белые',
	},
	{
		id: 'custom-black',
		type: VehicleNumberPlateType.CustomBlack,
		hasFlag: false,
		isBlack: true,
		label: 'Именные черные',
	},
];
